<div mat-dialog-title>
  <h2>Import CSV</h2>
  <eiq-button
    [title]="'Close import csv picker dialog'"
    [color]="'light'"
    [style]="'icon'"
    [icon]="faClose"
    class="mat-dialog-title__close"
    (clicked)="onCancel()"
  ></eiq-button>
</div>
<div mat-dialog-content class="import-csv-dialog__content">
  @if (uploadedFilePreview$()) {
    <mat-card class="import-csv-dialog__content__preview">
      <mat-card-content class="import-csv-dialog__content__preview__content">
        <span class="fs__md fw__600">{{ uploadedFilePreview$().file.name }}</span>
        <div class="import-csv-dialog__content__preview__content__info">
          <span class="fs__sm fw__400">{{ uploadedFilePreview$().file.type }}</span>
          <span class="fs__sm fw__600">{{ uploadedFile$().length }} terms</span>
        </div>

        @if (badFormattedCsv$()) {
          <span class="fs__sm fw__600 import-csv-dialog__content__preview__content-error"
            >Some terms were not added correctly due to formatting issues. Please check the CSV format requirements.</span
          >
        }

        <div class="import-csv-dialog__content__preview__content-delete">
          <button mat-icon-button title="Delete term" (click)="uploadedFile$.set(null); uploadedFilePreview$.set(null)">
            <fa-icon [icon]="faTrash" color="light"></fa-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  } @else {
    <eiq-file-uploader
      [acceptedTypes]="[fileType.TextCsv]"
      [acceptedTypesText]="[fileTypeExtension.Csv]"
      [maxSize]="null"
      [multiple]="false"
      (uploaded)="onUpload($event)"
    ></eiq-file-uploader>
  }

  <mat-card class="import-csv-dialog__content__card">
    <mat-card-content>
      <div class="import-csv-dialog__content__card-title">
        <fa-icon [icon]="faCircleInfo"></fa-icon>
        <span class="fs__md fw__600">CSV Format Requirements</span>
      </div>

      <div class="import-csv-dialog__content__card-description">
        <span class="fs__sm fw__400">Upload a CSV with two columns: Term (text to flag) and Method (contains or exact match), with one term per row.</span>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()">Close</button>
  <button mat-flat-button cdkFocusInitial [color]="'primary'" [disabled]="!uploadedFilePreview$() || !uploadedFile$().length" (click)="onImport()">
    Import
  </button>
</div>
